import { Box, HStack, Text } from '@chakra-ui/react'
import { Tooltip } from '~/components/ui/tooltip'
import { getRegionConfig } from '~/constants/regions'
import { getApiEnvironment } from '~/utils/common'

export const RegionIndicator = (props: {
  variant?: 'flag' | 'name' | 'both'
}) => {
  const { variant = 'flag' } = props
  const currentEnv = getApiEnvironment()
  const regionConfig = getRegionConfig(currentEnv)
  const { FlagIcon } = regionConfig

  const renderContent = () => {
    switch (variant) {
      case 'flag':
        return <FlagIcon width="20" height="15" />
      case 'name':
        return (
          <Text fontSize="sm" fontWeight="medium">
            {regionConfig.getLocalizedName()}
          </Text>
        )
      case 'both':
        return (
          <HStack gap={2}>
            <FlagIcon width="20" height="15" />
            <Text fontSize="sm" fontWeight="medium">
              {regionConfig.getLocalizedName()}
            </Text>
          </HStack>
        )
    }
  }

  return (
    <Tooltip
      content={regionConfig.fullName}
      showArrow
      positioning={{ placement: 'bottom' }}
    >
      <Box cursor="default" alignContent={'center'}>
        {renderContent()}
      </Box>
    </Tooltip>
  )
}
